import React from "react";

import { useTranslation } from "react-i18next";

import { GreyContainer } from "../../../../components/wrappers";
import { Input } from "../../../../components/inputs/Input/Input";

import "./styles.css";

interface CalculatePaymentProps {
  quantity: string;
  handleChange: (newQuantity: string) => void;
}

export const CalculatePayment = ({
  quantity,
  handleChange,
}: CalculatePaymentProps) => {
  const { t } = useTranslation();

  return (
    <GreyContainer>
      <h2 className="calculate-payment-text">{t("home.input")}</h2>
      <Input
        className="calculate-payment-input"
        type="number"
        placeholder={t("home.input_placeholder")}
        name="quantity"
        value={quantity}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          handleChange(e.target.value)
        }
      />
      <span className="calculate-payment-input-text">USDT</span>
    </GreyContainer>
  );
};
